module.exports = __webpack_public_path__ + "img/head straight.93614351.png";